{
	"themeName": "default",
	"colorPalette": "light",
	"isPanelless": false,
	"backgroundImage": "",
	"backgroundImageFit": "cover",
	"backgroundImageAttachment": "scroll",
	"backgroundOpacity": 1,
	"cssVariables": {
		"--sjs-editorpanel-cornerRadius": "4px",
		"--sjs-questionpanel-cornerRadius": "4px",
		"--sjs-questionpanel-hovercolor": "rgba(242, 245, 247, 1)",
		"--sjs-font-family": "Inter, Helvetica Neue, sans-serif",
		"--sjs-font-size": "16px",
		"--sjs-corner-radius": "6px",
		"--sjs-base-unit": "8px",
		"--sjs-font-pagetitle-family": "Inter, Helvetica Neue, sans-serif",
		"--sjs-font-pagetitle-size": "30px",
		"--sjs-font-pagetitle-color": "rgba(16, 24, 40, 1)",
		"--sjs-font-pagedescription-family": "Inter, Helvetica Neue, sans-serif",
		"--sjs-font-pagedescription-weight": "400",
		"--sjs-font-pagedescription-size": "20px",
		"--sjs-font-pagedescription-color": "rgba(52, 64, 84, 0.45)",
		"--sjs-shadow-small": "0px 0px 0px 1px rgba(0, 0, 0, 0.15)",
		"--sjs-font-questiontitle-family": "Inter, Helvetica Neue, sans-serif",
		"--sjs-font-questiontitle-size": "20px",
		"--sjs-font-questiontitle-color": "rgba(16, 24, 40, 1)",
		"--sjs-font-questiondescription-family": "Inter, Helvetica Neue, sans-serif",
		"--sjs-font-questiondescription-size": "18px",
		"--sjs-font-questiondescription-color": "rgba(0, 0, 0, 1)",
		"--sjs-shadow-inner": "0px 0px 0px 1px rgba(0, 0, 0, 0.15)",
		"--sjs-font-editorfont-family": "Inter, Helvetica Neue, sans-serif",
		"--sjs-font-editorfont-size": "18px",
		"--sjs-font-editorfont-color": "rgba(0, 0, 0, 1)",
		"--sjs-border-default": "rgba(0, 0, 0, 0.16)",
		"--sjs-border-light": "rgba(0, 0, 0, 0.09)",
		"--sjs-general-backcolor": "#ffffff",
		"--sjs-general-backcolor-dark": "#ffffff",
		"--sjs-general-backcolor-dim-light": "rgba(255, 255, 255, 1)",
		"--sjs-general-backcolor-dim-dark": "rgba(243, 243, 243, 1)",
		"--sjs-general-forecolor": "#1f2937",
		"--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.45)",
		"--sjs-general-dim-forecolor": "#4b5563",
		"--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
		"--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
		"--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
		"--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
		"--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
		"--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
		"--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.15)",
		"--sjs-shadow-medium": "0px 0px 0px 1px rgba(0, 0, 0, 0.1)",
		"--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.05)",
		"--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.15)",
		"--sjs-border-inside": "rgba(0, 0, 0, 0.16)",
		"--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
		"--sjs-special-green": "rgba(25, 179, 148, 1)",
		"--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
		"--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
		"--sjs-special-blue": "rgba(67, 127, 217, 1)",
		"--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
		"--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
		"--sjs-special-yellow": "rgba(255, 152, 20, 1)",
		"--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
		"--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
		"--sjs-article-font-xx-large-textDecoration": "none",
		"--sjs-article-font-xx-large-fontWeight": "700",
		"--sjs-article-font-xx-large-fontStyle": "normal",
		"--sjs-article-font-xx-large-fontStretch": "normal",
		"--sjs-article-font-xx-large-letterSpacing": "0",
		"--sjs-article-font-xx-large-lineHeight": "64px",
		"--sjs-article-font-xx-large-paragraphIndent": "0px",
		"--sjs-article-font-xx-large-textCase": "none",
		"--sjs-article-font-x-large-textDecoration": "none",
		"--sjs-article-font-x-large-fontWeight": "700",
		"--sjs-article-font-x-large-fontStyle": "normal",
		"--sjs-article-font-x-large-fontStretch": "normal",
		"--sjs-article-font-x-large-letterSpacing": "0",
		"--sjs-article-font-x-large-lineHeight": "56px",
		"--sjs-article-font-x-large-paragraphIndent": "0px",
		"--sjs-article-font-x-large-textCase": "none",
		"--sjs-article-font-large-textDecoration": "none",
		"--sjs-article-font-large-fontWeight": "700",
		"--sjs-article-font-large-fontStyle": "normal",
		"--sjs-article-font-large-fontStretch": "normal",
		"--sjs-article-font-large-letterSpacing": "0",
		"--sjs-article-font-large-lineHeight": "40px",
		"--sjs-article-font-large-paragraphIndent": "0px",
		"--sjs-article-font-large-textCase": "none",
		"--sjs-article-font-medium-textDecoration": "none",
		"--sjs-article-font-medium-fontWeight": "700",
		"--sjs-article-font-medium-fontStyle": "normal",
		"--sjs-article-font-medium-fontStretch": "normal",
		"--sjs-article-font-medium-letterSpacing": "0",
		"--sjs-article-font-medium-lineHeight": "32px",
		"--sjs-article-font-medium-paragraphIndent": "0px",
		"--sjs-article-font-medium-textCase": "none",
		"--sjs-article-font-default-textDecoration": "none",
		"--sjs-article-font-default-fontWeight": "400",
		"--sjs-article-font-default-fontStyle": "normal",
		"--sjs-article-font-default-fontStretch": "normal",
		"--sjs-article-font-default-letterSpacing": "0",
		"--sjs-article-font-default-lineHeight": "28px",
		"--sjs-article-font-default-paragraphIndent": "0px",
		"--sjs-article-font-default-textCase": "none",
		"--sjs-general-backcolor-dim": "#ffffff",
		"--sjs-primary-backcolor": "#5471f1",
		"--sjs-primary-backcolor-dark": "#425bcc",
		"--sjs-primary-backcolor-light": "rgba(37, 137, 229, 0.1)",
		"--sjs-primary-forecolor": "#ffffff",
		"--sjs-primary-forecolor-light": "rgba(229, 240, 252, 0.25)",
		"--sjs-special-red": "rgba(229, 10, 62, 1)",
		"--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
		"--sjs-header-backcolor": "#f2f5f7",
		"--sjs-transition-duration": "300ms"
	},
	"header": {
		"height": 0,
		"mobileHeight": 0,
		"inheritWidthFrom": "survey",
		"textAreaWidth": 0,
		"backgroundImageFit": "cover",
		"backgroundImageOpacity": 100,
		"overlapEnabled": false,
		"logoPositionX": "left",
		"logoPositionY": "top",
		"titlePositionX": "left",
		"titlePositionY": "bottom",
		"descriptionPositionX": "left",
		"descriptionPositionY": "bottom"
	},
	"headerView": "basic"
}
